import { getBaseUrl, request } from 'src/helper/api';

export const addIssueFromServiceRequest = (
  serviceRequestId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/actions/createIssue`,
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'issues/addIssue',
  );
export const editIssueFromServiceRequest = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
  signal?: AbortSignal,
) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/updateIssue`,
      contentType: 'json',
      token,
      signal,
      shouldAddSocketId: true,
    },
    'issues/editIssue',
  );

export const cancelIssue = (serviceRequestId?: string, issueId?: string, token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/cancelIssue`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/cancelIssue',
  );

export const deleteIssue = (serviceRequestId?: string, issueId?: string, token?: string) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/deleteIssue`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/deleteIssue',
  );

export const approveIssue = (serviceRequestId?: string, issueId?: string, token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/approveIssue`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/approveIssue',
  );

export const assignIssueToExistingWoFromServiceRequest = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/assignIssue`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/assignIssueToExistingWo',
  );
export const unassignIssueFromServiceRequest = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/unassignIssue`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/unassignIssue',
  );

export const assignIssueToExistingWoFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/assign`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/assignIssueToExistingWoFromWorkOrder',
  );

export const unassignIssueFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/unassign`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/unassignIssueFromWorkOrder',
  );

export const updateIssueDataFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/updateBasicDetails`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/updateBasicDetails',
  );

export const createIssueFromWorkOrder = (workOrderId?: string, token?: string) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/actions/create`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/createIssueFromWorkOrder',
  );

export const addIssueRecommendedItem = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/addIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/addIssueRecommendedItem',
    { issueId },
  );

export const updateIssueRecommendedItem = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/updateIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/updateIssueRecommendedItem',
    { issueId },
  );

export const deleteIssueRecommendedItem = (
  serviceRequestId?: string,
  issueId?: string,
  token?: string,
  itemId?: string,
  itemType?: 'tool' | 'material',
) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/service-requests/${serviceRequestId}/issues/${issueId}/actions/deleteIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/deleteIssueRecommendedItem',
    { issueId, issue_recommended_item_id: itemId, item_type: itemType },
  );

export const addIssueRecommendedItemFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/addIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/addIssueRecommendedItemFromWorkOrder',
    { issueId },
  );

export const updateIssueRecommendedItemFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
) =>
  request(
    {
      method: 'PUT',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/updateIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/updateIssueRecommendedItemFromWorkOrder',
    { issueId },
  );

export const deleteIssueRecommendedItemFromWorkOrder = (
  workOrderId?: string,
  issueId?: string,
  token?: string,
  itemId?: string,
  itemType?: 'tool' | 'material',
) =>
  request(
    {
      method: 'DELETE',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${issueId}/actions/deleteIssueRecommendedItem`,
      contentType: 'json',
      token,
      shouldAddSocketId: true,
    },
    'issues/deleteIssueRecommendedItemFromWorkOrder',
    { issueId, issue_recommended_item_id: itemId, item_type: itemType },
  );

export const getTripDetails = (
  token?: string,
  workOrderId?: string,
  issueId?: string,
  tripId?: string,
  workOrderIssueId?: string,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/work-orders/${workOrderId}/issues/${workOrderIssueId || issueId}/trip/${tripId}/getTripDetails`,
      contentType: 'json',
      token,
    },
    'issues/getTripDetails',
    { issueId },
  );
